export default "__VITE_ASSET__joxnxz_u__"